<template>
  <b-modal
    v-model="localShow"
    ok-title="ذخیره"
    cancel-title="انصراف"
    cancel-variant="outline-secondary"
    centered
    title="جزئیات سفارش"
    :no-close-on-backdrop="true"
    size="lg"
    @ok="onSave"
  >
    <b-col cols="12">
      <b-row class="mt-15">
        <b-col cols="4">
          <div class="modal-item-title">
            عنوان تور
          </div>
          <div>{{ localOrder.Tour.Title }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            تاریخ رفت تور
          </div>
          <div>{{ localOrder.Tour.Departure| date('jYYYY-jMM-jDD') }}</div>
        </b-col>
      </b-row>

      <b-row class="mt-15">
        <b-col cols="4">
          <div class="modal-item-title">
            نام و نام خانوادگی
          </div>
          <div>{{ localOrder.Name }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            موبایل
          </div>
          <div>{{ localOrder.Mobile }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
           تاریخ سفارش
          </div>
          <div>{{ localOrder.CreatedAt | date('jYYYY-jMM-jDD') }} {{ localOrder.CreatedAt | date('HH:mm') }}</div>
        </b-col>
      </b-row>

      <b-row class="mt-15">
        <b-col cols="4">
          <div class="modal-item-title">
            بزرگسال
          </div>
          <div>{{ localOrder.Adult }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            کودک
          </div>
          <div>{{ localOrder.Child }}</div>
        </b-col>
        <b-col cols="4">
          <div class="modal-item-title">
            نوزاد
          </div>
          <div>{{ localOrder.Infant }}</div>
        </b-col>
      </b-row>


      <b-row class="mt-1">
        <b-col cols="12">
          <div class="modal-item-title">
            توضیحات
          </div>
          <div>{{ localOrder.Description }}</div>
        </b-col>
      </b-row>

    </b-col>

    <b-col class="mt-1">
      <b-row>

        <!--        <b-col md="8">-->
        <!--          <b-form-group-->
        <!--              label="Note"-->
        <!--              label-for="Note"-->
        <!--          >-->
        <!--            <b-form-input-->
        <!--                id="Note"-->
        <!--                :value="localGame.Status == 2 ? localGame.Note : ''"-->
        <!--                name="Note"-->
        <!--                autocomplete="off"-->
        <!--                @input="localGame.Note = $event"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->

        <b-col md="4">
          <b-form-group
            label="وضعیت"
            label-for="Status"
          >
            <v-select
              v-model="localOrder.Status"
              :options="enums('OrderStatus')"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>

  </b-modal>
</template>

<script>
export default {
  name: 'OrderDetails',

  props: {
    value: Boolean, // v-model
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localShow: this.value,
      localOrder: JSON.parse(JSON.stringify(this.order)),
    }
  },
  watch: {
    value(val) {
      this.localShow = val
    },
    localShow(val) {
      this.$emit('input', val)
    },
    game: {
      deep: true,
      handler(val) {
        this.localOrder = JSON.parse(JSON.stringify(val))
      },
    },
  },
  methods: {
    onSave() {
      this.$emit('save', this.localOrder)
    },
  },

}
</script>

<style scoped>
.modal-item-title{
  font-weight: 600;
  color: #5e5873;
  font-size: 0.857rem;
  margin-bottom: 0.2857rem;
}
</style>
